import { slugify } from './slugify.cjs';

export const getMagazineArticleLink = (slug) => {
  return `/if-magazine/${slugify(slug, true)}`;
};
